import { IPreventTransientAccessQueryResult } from '../../prevent_transient_access/queries/prevent_transient_access_query';
import { ClearTransientAccessCredCommand } from '../../prevent_transient_access/commands/clear_transient_access_cred_command';
import { ITransientAccessCred } from '../../prevent_transient_access/builders/transient_access_cred_builder';
import { RegAttributesForSections } from '../../interfaces/scheduler_interfaces';
import { ISectionSwapToFrom } from '../models/course_section_swap_model';
import { IDefineCommand, ICommand } from 'core-ts-types';
import { RegistrationAlertsServant } from '../../views/course_scheduler/servants/registration_alerts_servant';
import { RegistrationAlertMessages } from '../../views/course_scheduler/types/registration_alert_messages';
import { SchedulerModel } from '../../views/course_scheduler/models/scheduler_model';
import { SwapCallbackServant } from '../servants/section_swap_callback_servant';
import { ISectionSwap } from '../interfaces/swap_section_interface';
import * as _4 from 'lodash4';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { RegistrationReceiptServant } from '../../views/course_scheduler/servants/registration_receipt_servant';
import { RegistrationRecieptCommand } from '../../registration_receipt/commands/registration_reciept_command';
import { INotificationDelegate } from '../../global/helpers/scheduler_notification_delegate';
import { SectionInfoServant } from '../../views/sections/servants/section_info_servant';
import { SwapRequestStateCommand } from '../../request_state/commands/swap_request_state_command';

export type SaveSwapCommand = (
  termId: number,
  fromData: Array<ISectionSwapToFrom['id']>,
  toData: Array<ISectionSwapToFrom['id']>,
  section_pins: Record<string, any>,
  regAttributesForSections?: RegAttributesForSections,
  student_credentials?: IPreventTransientAccessQueryResult['output']
) => ng.IPromise<undefined | Record<string, any>>;

angular
  .module('capability-ng-scheduler')
  .service(
    'saveSwapCommand',
    function saveSwapCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      log: any,
      $q: ng.IQService,
      pusherService: any,
      ngCourseSectionSwapModel: any,
      $timeout: ng.ITimeoutService,
      ngSchedulerModel: SchedulerModel,
      ngSwapCallbackServant: SwapCallbackServant,
      ngSectionInfoServant: SectionInfoServant,
      registrationActivityCommand: ICommand,
      registrationRecieptCommand: RegistrationRecieptCommand,
      getTermCoursesandScheduledSectionsCommand: ICommand,
      ngRegistrationReceiptServant: RegistrationReceiptServant,
      ngSectionsDatasource: ISectionsDatasource,
      clearTransientAccessCredCommand: ClearTransientAccessCredCommand,
      ngRegistrationAlertsServant: RegistrationAlertsServant,
      ngSchedulerNotificationDelegate: INotificationDelegate,
      swapRequestStateCommand: SwapRequestStateCommand
    ) {
      'use strict';

      return defineCommandORM(
        'saveSwapCommand',
        function saveSwapCommand(
          deferred,
          termId: number,
          fromData: Array<ISectionSwapToFrom['id']>,
          toData: Array<ISectionSwapToFrom['id']>,
          section_pins: Record<string, any> = {},
          regAttributeForToSections?: RegAttributesForSections,
          student_credentials?: ITransientAccessCred
        ) {
          // Timeout after 60 seconds
          const SECONDS_60 = 60000;
          const timeout = $q.defer();

          $timeout(() => {
            swapRequestStateCommand(false);
            timeout.resolve();
          }, SECONDS_60);
          const schedulerModel = ngSchedulerModel.read();

          let fromCourseSectionTitle = '';
          const sectionStatusesBeforeSwap = {};
          _4.each(fromData, (sectionId: number) => {
            const sctn = ngSectionsDatasource.get(sectionId);
            if (sctn) {
              const sectionLabel = ngSectionInfoServant.getSectionLabel(sctn);
              const courseLabel = `${sctn._course.cd} ${sctn._course.title} ${sectionLabel}`;
              if (_4.isEmpty(fromCourseSectionTitle)) {
                fromCourseSectionTitle = courseLabel;
              } else {
                fromCourseSectionTitle = `${fromCourseSectionTitle}, ${courseLabel}`;
              }

              sectionStatusesBeforeSwap[sectionId] = sctn.status;
            }
          });

          const swapCallback = (data: ISectionSwap) => {
            const sectionIds = [...fromData, ...toData];
            registrationActivityCommand(termId)
              .then(() => {
                const sectionsReceiptData = _4.filter(
                  ngRegistrationReceiptServant.getReceiptData(sectionIds),
                  'isActiveRecord'
                );
                return $q.all([
                  registrationRecieptCommand(sectionsReceiptData, true),
                  getTermCoursesandScheduledSectionsCommand(termId)
                ]);
              })
              .finally(() => swapRequestStateCommand(false));

            if (data.is_swapped) {
              ngSwapCallbackServant.swapSuccess(data);
            } else {
              ngSwapCallbackServant.swapFails(data, sectionStatusesBeforeSwap);
            }
          };

          ngRegistrationAlertsServant.showPendingAlert(RegistrationAlertMessages.PENDING_SWAP_TEXT);
          swapRequestStateCommand(true);

          pusherService.bindToPusherEvent(schedulerModel.channel_name, 'registration_outcome_swap', swapCallback);

          $http
            .post('/reg/swap/term/' + termId, {
              swap_from_section_ids: fromData,
              swap_to_section_ids: toData,
              section_pins,
              ...regAttributeForToSections,
              ...student_credentials
            })
            .then(
              (response) => {
                return clearTransientAccessCredCommand().then(() => {
                  deferred.resolve(response.data);
                  ngRegistrationAlertsServant.hidePendingAlert();
                  ngRegistrationAlertsServant.createGenericNotification(
                    `${fromCourseSectionTitle} successfully swapped`,
                    'success'
                  );
                  ngCourseSectionSwapModel.clear();
                });
              },
              (response) => {
                clearTransientAccessCredCommand();
                log.issue('failed to swap sections');
                if (_4.has(response, 'data.detail')) {
                  ngSchedulerNotificationDelegate.warn(response.data.detail);
                }
                deferred.reject(response.data);
                ngRegistrationAlertsServant.hidePendingAlert();
                swapRequestStateCommand(false);
                ngRegistrationAlertsServant.createGenericNotification(
                  'Your request for swap failed.  Please try again.',
                  'error'
                );
              }
            );
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/save_swap_command.ts